import reportService from "@/services/report";

export default {
  data: () => ({
    reportItem: [],
  }),
  methods: {
    async fetchTakenReport(params, companyId = null) {
      if (this.loading !== undefined) {
        this.loading = true;
      }

      const requestId = (this.takenRequestId = (this.takenRequestId || 0) + 1);
      try {
        // useSummary (opciono, definiše komponenta): gotovi zbirovi po firmi, jelu i smeni.
        // Redovi su bez id-a narudžbe, pa se koristi samo za prikaz po jelima i sve firme.
        const response =
          this.useSummary && companyId === null
            ? await reportService.getFoodOrdersSummary(this.$store.state.restaurant.id, params)
            : await reportService.getFoodOrdersOrdered(this.$store.state.restaurant.id, params);
        if (requestId !== this.takenRequestId) return;
        this.reportItem = response.data.filter((item) => {
          return item.company_id === companyId || companyId === null;
        });
      } catch (error) {
        if (requestId !== this.takenRequestId) return;
        console.error("Error fetching taken report:", error);
        this.reportItem = [];
      } finally {
        if (this.loading !== undefined && requestId === this.takenRequestId) {
          this.loading = false;
        }
      }
    },
  },
  computed: {
    filters() {
      return this.$store.state.report.filters;
    },
  },
};
